import classNames from "classnames";
import Icon from "../Icon/Icon";
import Styles from "./Text.module.scss";
const Title = ({ iconName, text }) => {
  return (
    <div className={classNames("container", Styles.title)}>
      <Icon iconName={iconName} />
      <p>{text}</p>
    </div>
  );
};
export default Title;
